import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const Footer = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className } = _a, props = __rest(_a, ["as", "className"]);
    return (React.createElement(Component, Object.assign({ className: clsx('layout-footer', className), ref: ref }, props)));
});
Footer.displayName = 'Footer';
export { Footer };
//# sourceMappingURL=Footer.js.map